/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import classNames from 'classnames';
import React from 'react';
import styles from './styles.sass';

type Height = 40 | 46 | 50 | 70;

type CommonProps = {
  children: React.ReactNode;
  isDisabled?: boolean;
  color?: 'white' | 'purple' | 'red' | 'green';
  className?: string;
  height?: Height;
};

type ButtonProps = {
  kind: 'button';
  onClick: () => void;
  type?: 'button' | 'submit' | 'reset';
} & CommonProps;

type LinkProps = {
  kind: 'link';
  href: string;
  target?: string;
} & CommonProps;

type Props = ButtonProps | LinkProps;

export const Button = (props: Props): JSX.Element => {
  const { isDisabled, className, color, children, height } = props;
  const cx = classNames(
    styles.button,
    color !== undefined ? styles[color] : null,
    className !== undefined ? { [className]: className } : null,
    { [styles.disabled]: isDisabled }
  );
  const cssProp = css`
    height: ${height}px;
  `;

  switch (props.kind) {
    case 'link': {
      const { href, target } = props;
      return (
        <a href={href} className={cx} css={cssProp} target={target}>
          {children}
        </a>
      );
    }
    case 'button': {
      const { type, onClick } = props;
      return (
        <button type={type} className={cx} onClick={onClick} css={cssProp}>
          {children}
        </button>
      );
    }
  }
};

Button.defaultProps = {
  kind: 'button',
  height: 46,
};
